/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fm-fit-to-map',
  templateUrl: './fit-to-map.component.html',
  styleUrls: ['./fit-to-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FitToMapComponent {
  @Input()
  public isLarge = false;

  @Output()
  public trigger: EventEmitter<void> = new EventEmitter();

  public onClick(): void {
    this.trigger.emit();
  }
}
